import { render, staticRenderFns } from "./watches.vue?vue&type=template&id=3758c05f&lang=pug"
import script from "./watches.vue?vue&type=script&lang=js"
export * from "./watches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports